// import { useEffect, useRef, useState, useCallback } from "react";

// /**
//  * KuCoin Spot WS (ticker + Level50 + snapshot 24h)
//  *  - token:  POST https://api.kucoin.com/api/v1/bullet-public
//  *  - ws:     wss://ws-api-spot.kucoin.com?token=...&connectId=...
//  *  - topics: /market/ticker:{SYM}, /spotMarket/level2Depth50:{SYM}, /market/snapshot:{SYM}
//  *  SYM формат: BTC-USDT
//  */
// export const useKucoinSpot = (symbol) => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [error, setError] = useState(null);
//   const [tickerData, setTickerData] = useState(null); // { lastPrice, volume24, bid, ask }
//   const [orderBook, setOrderBook] = useState({ asks: [], bids: [] });

//   const wsRef = useRef(null);
//   const pingTimerRef = useRef(null);
//   const animationFrameRef = useRef(null);

//   const orderBookRef = useRef({ asks: [], bids: [] });
//   const readyToSubRef = useRef(false);

//   const log = (...a) => console.log("🟦 [KUCOIN SPOT]", ...a);
//   const PROXY_ORIGIN = process.env.REACT_APP_BACKEND_URL;
//   const viaProxy = (absUrl) => `${PROXY_ORIGIN}/proxy/${encodeURI(absUrl)}`;
//   const TOKEN_URL_SPOT = `${PROXY_ORIGIN}/https://api.kucoin.com/api/v1/bullet-public`;

//   const toPairs = (rows) => Array.isArray(rows) ? rows.map(([p, q]) => [String(p), String(q)]) : [];

//   const applyFullBook = useCallback((asks, bids) => {
//     orderBookRef.current = {
//       asks: asks.slice(0, 20).sort((a, b) => parseFloat(a[0]) - parseFloat(b[0])),
//       bids: bids.slice(0, 20).sort((a, b) => parseFloat(b[0]) - parseFloat(a[0])),
//     };
//     if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
//     animationFrameRef.current = requestAnimationFrame(() => {
//       setOrderBook({ ...orderBookRef.current });
//     });
//   }, []);

//   const buildTopics = useCallback((inst) => ({
//     ticker:   `/market/ticker:${inst}`,
//     level50:  `/spotMarket/level2Depth50:${inst}`,
//     snapshot: `/market/snapshot:${inst}`,
//   }), []);

//   const subscribeAll = useCallback((ws, inst) => {
//     const { ticker, level50, snapshot } = buildTopics(inst);
//     const id = Date.now();
//     const subs = [
//       { id,     type: "subscribe", topic: ticker,   response: true },
//       { id: id+1, type: "subscribe", topic: level50, response: true },
//       { id: id+2, type: "subscribe", topic: snapshot, response: true },
//     ];
//     subs.forEach(m => ws.send(JSON.stringify(m)));
//     log("→ SUB", subs);
//   }, [buildTopics]);

//   const unsubscribeAll = useCallback((ws, inst) => {
//     try {
//       const { ticker, level50, snapshot } = buildTopics(inst);
//       const id = Date.now();
//       const us = [
//         { id,     type: "unsubscribe", topic: ticker,   response: true },
//         { id: id+1, type: "unsubscribe", topic: level50, response: true },
//         { id: id+2, type: "unsubscribe", topic: snapshot, response: true },
//       ];
//       us.forEach(m => ws?.send(JSON.stringify(m)));
//       log("→ UNSUB", us);
//     } catch {}
//   }, [buildTopics]);

//   const fetchWsConfig = useCallback(async () => {
//     const url = viaProxy(TOKEN_URL_SPOT);
//     try {
//       const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r.ok) throw new Error(`HTTP ${r.status}`);
//       return await r.json();
//     } catch {
//       const r2 = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r2.ok) throw new Error(`HTTP ${r2.status}`);
//       return await r2.json();
//     }
//   }, []);

//   const handleMessage = useCallback((event) => {
//     try {
//       if (typeof event.data !== "string") return;
//       const msg = JSON.parse(event.data);

//       if (msg.type === "welcome") { readyToSubRef.current = true; return; }
//       if (msg.type === "pong" || msg.type === "ack") return;

//       // ----- тикер -----
//       if (msg.topic?.startsWith("/market/ticker:") && msg.type === "message") {
//         const d = msg.data || {};
//         setTickerData(prev => ({
//           ...(prev || {}),
//           symbol,
//           lastPrice: d.price ?? prev?.lastPrice,
//           bid: d.bestBid,
//           ask: d.bestAsk,
//         }));
//         return;
//       }

//       // ----- стакан Level50 -----
//       if (msg.topic?.startsWith("/spotMarket/level2Depth50:") && msg.type === "message") {
//         const d = msg.data || {};
//         applyFullBook(toPairs(d.asks), toPairs(d.bids));
//         return;
//       }

//       // ----- SNAPSHOT 24H (каждые ~2s) -----
//       if (msg.topic?.startsWith("/market/snapshot:") && msg.type === "message") {
//         const root = msg.data || {};
//         const snap = root.data || root; // иногда data.data
//         // предпочтительно брать quote объём (USDT)
//         const volQ = snap?.marketChange24h?.volValue ?? snap?.volValue;
//         const last = snap?.lastTradedPrice ?? snap?.close;

//         setTickerData(prev => ({
//           ...(prev || {}),
//           symbol,
//           lastPrice: last != null ? String(last) : (prev?.lastPrice ?? ""),
//           volume24: volQ != null ? String(volQ) : (prev?.volume24 ?? ""),
//         }));
//         return;
//       }
//     } catch (e) {
//       log("❌ parse error:", e);
//     }
//   }, [applyFullBook, symbol]);

//   useEffect(() => {
//     if (!symbol) return;

//     const inst = symbol.includes("-") ? symbol : `${symbol}-USDT`;

//     setIsConnected(false);
//     setError(null);
//     setTickerData(null);
//     setOrderBook({ asks: [], bids: [] });
//     orderBookRef.current = { asks: [], bids: [] };
//     readyToSubRef.current = false;

//     let ws;
//     let pingIntervalMs = 20000;

//     (async () => {
//       try {
//         const conf = await fetchWsConfig();
//         const data = conf?.data;
//         const server = data?.instanceServers?.[0];
//         if (!data?.token || !server?.endpoint) throw new Error("No token/endpoint");

//         pingIntervalMs = Number(server.pingInterval || 20000);
//         const connectId = String(Date.now());
//         const wsUrl = `${server.endpoint}?token=${encodeURIComponent(data.token)}&connectId=${connectId}`;

//         ws = new WebSocket(wsUrl);
//         wsRef.current = ws;

//         ws.onopen = () => {
//           log("🔗 open:", inst);
//           setIsConnected(true);

//           // heartbeat
//           pingTimerRef.current = setInterval(() => {
//             try { ws.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
//           }, Math.max(5000, pingIntervalMs - 1000));
//         };

//         ws.onmessage = (evt) => {
//           if (!readyToSubRef.current) {
//             try {
//               const probe = JSON.parse(evt.data);
//               if (probe?.type === "welcome") subscribeAll(ws, inst);
//             } catch {}
//           }
//           handleMessage(evt);
//         };

//         ws.onerror = (e) => {
//           log("❌ ws error:", e);
//           setError(e?.message || "WS error");
//           setIsConnected(false);
//         };
//         ws.onclose = () => {
//           log("🔌 close");
//           setIsConnected(false);
//         };
//       } catch (e) {
//         setError(e.message);
//         log("❌ token/ws init:", e);
//       }
//     })();

//     return () => {
//       try {
//         if (ws && ws.readyState === WebSocket.OPEN) {
//           unsubscribeAll(ws, inst);
//           ws.close();
//         }
//       } catch {}
//       if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
//       if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
//       wsRef.current = null;
//     };
//   }, [symbol, fetchWsConfig, handleMessage, subscribeAll, unsubscribeAll]);

//   return { isConnected, error, orderBook, tickerData };
// };
/* eslint-disable max-len */
import { useEffect, useRef, useState, useCallback } from "react";

const PROXY = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const log = (...a) => console.log("🟦 [KUCOIN SPOT]", ...a);

const normSpot = (s) => (s.includes("-") ? s : `${s}-USDT`).toUpperCase();
const toPairs = (rows) => Array.isArray(rows) ? rows.map(([p, q]) => [String(p), String(q)]) : [];

function normalizeKucoinSpotEndpoint(endpoint) {
  try {
    const u = new URL(endpoint);
    if (!u.hostname.endsWith("kucoin.com")) {
      u.hostname = "ws-api-spot.kucoin.com";
      u.protocol = "wss:";
    }
    return u.toString();
  } catch {
    return "wss://ws-api-spot.kucoin.com";
  }
}

export const useKucoinSpot = (symbol) => {
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const [tickerData, setTickerData] = useState(null);
  const [orderBook, setOrderBook] = useState({ asks: [], bids: [] });

  const wsRef = useRef(null);
  const pingTimerRef = useRef(null);
  const animationFrameRef = useRef(null);

  const applyFullBook = useCallback((asks, bids) => {
    const ob = {
      asks: asks.slice(0, 20).sort((a,b)=>+a[0]-+b[0]),
      bids: bids.slice(0, 20).sort((a,b)=>+b[0]-+a[0]),
    };
    if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    animationFrameRef.current = requestAnimationFrame(() => setOrderBook(ob));
  }, []);

  const buildTopics = useCallback((inst) => ({
    ticker:   `/market/ticker:${inst}`,
    level50:  `/spotMarket/level2Depth50:${inst}`,
    snapshot: `/market/snapshot:${inst}`,
  }), []);

  const subscribeAll = useCallback((ws, inst) => {
    const { ticker, level50, snapshot } = buildTopics(inst);
    const id = Date.now();
    const subs = [
      { id,       type: "subscribe", topic: ticker,   response: true },
      { id: id+1, type: "subscribe", topic: level50, response: true },
      { id: id+2, type: "subscribe", topic: snapshot, response: true },
    ];
    subs.forEach(m => ws.send(JSON.stringify(m)));
    log("→ SUB", subs);
  }, [buildTopics]);

  const unsubscribeAll = useCallback((ws, inst) => {
    try {
      const { ticker, level50, snapshot } = buildTopics(inst);
      const id = Date.now();
      const us = [
        { id,       type: "unsubscribe", topic: ticker,   response: true },
        { id: id+1, type: "unsubscribe", topic: level50, response: true },
        { id: id+2, type: "unsubscribe", topic: snapshot, response: true },
      ];
      us.forEach(m => ws?.send(JSON.stringify(m)));
      log("→ UNSUB", us);
    } catch {}
  }, [buildTopics]);

  const fetchWsConfig = useCallback(async () => {
    const url = `${PROXY}/https://api.kucoin.com/api/v1/bullet-public`;
    const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const conf = await r.json();
    const server = conf?.data?.instanceServers?.[0];
    const token  = conf?.data?.token;
    if (!server?.endpoint || !token) throw new Error("No token/endpoint");
    return { endpoint: normalizeKucoinSpotEndpoint(server.endpoint), token, pingInterval: Number(server.pingInterval || 20000) };
  }, []);

  useEffect(() => {
    if (!symbol) return;

    const inst = normSpot(symbol);

    setIsConnected(false);
    setError(null);
    setTickerData(null);
    setOrderBook({ asks: [], bids: [] });

    let ws;
    let pingIntervalMs = 20000;

    (async () => {
      try {
        const { endpoint, token, pingInterval } = await fetchWsConfig();
        pingIntervalMs = pingInterval;

        // Собираем ws url корректно
        const u = new URL(endpoint);
        u.searchParams.set("token", token);
        u.searchParams.set("connectId", String(Date.now()));
        const wsUrl = u.toString();

        ws = new WebSocket(wsUrl);
        wsRef.current = ws;

        ws.onopen = () => {
          log("🔗 open:", inst);
          setIsConnected(true);
          // heartbeat
          pingTimerRef.current = setInterval(() => {
            try { ws.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
          }, Math.max(5000, pingIntervalMs - 1000));
        };

        ws.onmessage = (evt) => {
          try {
            const msg = JSON.parse(evt.data);

            if (msg.type === "welcome") {
              subscribeAll(ws, inst);
              return;
            }
            if (msg.type === "pong" || msg.type === "ack") return;

            if (msg.type === "message" && msg.topic?.startsWith("/market/ticker:")) {
              const d = msg.data || {};
              setTickerData(prev => ({
                ...(prev || {}),
                symbol: inst,
                lastPrice: d.price ?? prev?.lastPrice,
                bid: d.bestBid,
                ask: d.bestAsk,
              }));
              return;
            }

            if (msg.type === "message" && msg.topic?.startsWith("/spotMarket/level2Depth50:")) {
              const d = msg.data || {};
              applyFullBook(toPairs(d.asks), toPairs(d.bids));
              return;
            }

            if (msg.type === "message" && msg.topic?.startsWith("/market/snapshot:")) {
              const root = msg.data || {};
              const snap = root.data || root;
              const volQ = snap?.marketChange24h?.volValue ?? snap?.volValue;
              const last = snap?.lastTradedPrice ?? snap?.close;
              setTickerData(prev => ({
                ...(prev || {}),
                symbol: inst,
                lastPrice: (last != null) ? String(last) : (prev?.lastPrice ?? ""),
                volume24: (volQ != null) ? String(volQ) : (prev?.volume24 ?? ""),
              }));
              return;
            }
          } catch {}
        };

        ws.onerror = (e) => {
          log("❌ ws error:", e);
          setError(e?.message || "WS error");
          setIsConnected(false);
        };
        ws.onclose = () => {
          log("🔌 close");
          setIsConnected(false);
        };
      } catch (e) {
        setError(e.message);
        log("❌ token/ws init:", e);
      }
    })();

    return () => {
      try {
        if (ws && ws.readyState === WebSocket.OPEN) {
          unsubscribeAll(ws, inst);
          ws.close();
        }
      } catch {}
      if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
      if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
      wsRef.current = null;
    };
  }, [symbol, fetchWsConfig, applyFullBook, subscribeAll, unsubscribeAll]);

  return { isConnected, error, orderBook, tickerData };
};
